import { EventRow } from "./EventRow";
import { useOrganisationStyles } from "./useOrganisationStyles";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { T } from "../../util/t";
import { sortByDateDescending } from "../../../utils/sort";

export const FeaturedEvents = ({ organisation }) => {
    const classes = useOrganisationStyles();

    const hasEvents = organisation.events?.length > 0;

    const featuredEvents = () => {
        const sortedEvents = [...organisation.events].sort(sortByDateDescending);

        const liveEvents = sortedEvents.filter(
            event => event.status === "on"
        ).reverse();
        const upcomingEvents = sortedEvents.filter(
            event =>
                event.status === "scheduled" ||
                event.status === "upcoming" ||
                event.status === "drawn" ||
                event.status === "published"
        ).reverse();
        const nonLiveEvents = upcomingEvents.concat(sortedEvents.filter(
            event =>
                event.status !== "scheduled" &&
                event.status !== "upcoming" &&
                event.status !== "drawn" &&
                event.status !== "published" &&
                event.status !== "on"
        ));
        return liveEvents.concat(nonLiveEvents).slice(0,3);
    };

    return <>
        {hasEvents ?
            <>
                <div>{featuredEvents().map(event => <EventRow key={event.id} event={event} /> )}</div>
                <Button className={classes.button}
                        variant="outlined"
                        component={Link}
                        to={`/${organisation.shortName}/events`}
                        size="small"
                        fullWidth >
                    <T>View all events</T>
                </Button>
            </> :
            <Typography><T organisationName={organisation.name}>organisation_does_not_have_events</T></Typography>}
    </>;
};
